import { Link } from '@tanstack/react-router';

type Sibling = { slug: string; title: string } | null;

export function ArticleReader({ previous, next }: { previous: Sibling; next: Sibling }) {
  if (!previous && !next) return null;
  return (
    <div className="post-reader-text pt-5">
      <div className="row">
        {previous && (
          <div className="col-md-6">
            <div className="post-reader-prev">
              <span>السابق</span>
              <h4 className="title">
                <Link to="/articles/$slug" params={{ slug: previous.slug }}>
                  {previous.title}
                </Link>
              </h4>
            </div>
          </div>
        )}
        {next && (
          <div className="col-md-6">
            <div className="post-reader-prev">
              <span>التالي</span>
              <h4 className="title">
                <Link to="/articles/$slug" params={{ slug: next.slug }}>
                  {next.title}
                </Link>
              </h4>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
